// Copyright (c) Ensho Health, 2021 to present

import { gql } from 'graphql-request';
import { workflowClient } from './client-gql.js';

export async function fetchUser() {
  try {
    const query = gql`
      query {
        user {
          userName
          userId
          setupComplete
          hasCodAccess
          roles
          permissions
          cdlSubscriptions {
            cdlServiceCode
            cdlServiceLabel
            isSinglePatient
            isFullRoster
            isPanel
            isSponsored
          }
          account {
            accountId
            accountNumber
            billingInformation
            id
          }
          contactInfo {
            userId
            userContactInfoId
            contactEmail
            phone
            fax
            id
          }
          clinic {
            clinicId
            colleagues {
              userId
              email
              contactEmail
              phone
              fax
              firstName
              lastName
              accountId
              accountNumber
              billingInformation
            }
            name
            setupComplete
            setupUser
          }
        }
      }
    `;
    const response = await workflowClient.request(query);
    return response?.user;
  } catch (error) {
    throw error;
  }
}

export async function setupUser(info) {
  try {
    const query = gql`
      mutation userSetupComplete(
        $userId: String!
        $firstName: String!
        $lastName: String!
        $recoveryQuestion: String!
        $recoveryAnswer: String!
      ) {
        userSetupComplete(
          userId: $userId
          setupComplete: true
          firstName: $firstName
          lastName: $lastName
          recoveryQuestion: $recoveryQuestion
          recoveryAnswer: $recoveryAnswer
        ) {
          ok
          error
        }
      }
    `;
    const variables = {
      userId: info.userId,
      firstName: info.firstname,
      lastName: info.lastname,
      recoveryQuestion: info.recoveryQuestion,
      recoveryAnswer: info.recoveryAnswer
    };
    const response = await workflowClient.request(query, variables);
    if (response.userSetupComplete.ok) {
      return true;
    } else {
      const errorMessage =
        response.userSetupComplete.error ||
        'Unknown error while completing the user setup';
      throw new Error(errorMessage);
    }
  } catch (error) {
    throw error;
  }
}
